
import { useState, useEffect } from 'react';
import { useGame } from '../contexts/GameContext';
import { Milestone } from './milestones/types';
import {
  detectAchievementMilestone,
  detectSkillMilestone,
  detectYearMilestone,
  detectKpiMilestones
} from './milestones/milestoneDetection';

export const useMilestoneTracking = () => {
  const { 
    yearsPassed,
    achievements,
    skills,
    kpis,
    careerLevel
  } = useGame();
  
  const [currentMilestone, setCurrentMilestone] = useState<Milestone | null>(null);
  
  const [lastAchievementCount, setLastAchievementCount] = useState(achievements.length);
  const [lastSkillCount, setLastSkillCount] = useState(skills.length);
  const [lastYearPassed, setLastYearPassed] = useState(yearsPassed);
  const [lastKpis, setLastKpis] = useState(kpis);
  const [lastCareerLevel, setLastCareerLevel] = useState(careerLevel);

  // Check for new achievements, skills, or promotions
  useEffect(() => {
    // Check each milestone type in order of priority
    const achievementMilestone = detectAchievementMilestone(achievements, lastAchievementCount);
    if (achievementMilestone) {
      setCurrentMilestone(achievementMilestone);
      setLastAchievementCount(achievements.length);
    } 
    else {
      const skillMilestone = detectSkillMilestone(skills, lastSkillCount);
      if (skillMilestone) {
        setCurrentMilestone(skillMilestone);
        setLastSkillCount(skills.length);
      }
      else {
        const yearMilestone = detectYearMilestone(yearsPassed, lastYearPassed);
        if (yearMilestone) {
          setCurrentMilestone(yearMilestone);
        }
        else {
          const kpiMilestone = detectKpiMilestones(kpis, lastKpis);
          if (kpiMilestone) {
            setCurrentMilestone(kpiMilestone);
          }
        }
      }
    }
    
    setLastYearPassed(yearsPassed);
    setLastKpis(kpis);
  }, [achievements, skills, yearsPassed, kpis, lastAchievementCount, lastSkillCount, lastYearPassed, lastKpis]);

  return {
    currentMilestone,
    lastCareerLevel,
    setLastCareerLevel
  };
};
